const map = {
  performance: process.env.VUE_APP_PERFORMANCE_URL,
  wuling: process.env.VUE_APP_WULING_URL,
}

export default function hostMap(host) {
  return map[host]
}
